import React from "react";
import { List, Avatar, Checkbox, message } from "antd";

/**
 * props:
 *  tracks          – массив треков
 *  queueIds        – id, которые уже в корзине
 *  purchasedIds    – купленные id
 *  selectedIds     – id, отмеченные пользователем
 *  onToggle(id)    – обработчик изменения чек-бокса
 */
export default function TrackList({
  tracks, queueIds, purchasedIds, selectedIds, onToggle
}) {
  return (
    <List
      itemLayout="horizontal"
      dataSource={tracks}
      renderItem={t=>{
        const disabled = purchasedIds.includes(t.id);
        const checked  = disabled || queueIds.includes(t.id) || selectedIds.includes(t.id);

        const cover = t.track_cover_photo
          ? `https://audiobuzz-web.tmweb.ru/uploads/thumbnails/media/${t.track_cover_photo}`
          : "https://audiobuzz-web.tmweb.ru/uploads/thumbnails/default_cover.jpg";

        return (
          <List.Item>
            <Checkbox
              disabled={disabled}
              checked={checked}
              onChange={()=>{
                if (disabled){ message.info("Трек уже куплен"); return; }
                onToggle(t.id);
              }}
              style={{marginRight:12,opacity:disabled?0.4:1}}
            />
            <List.Item.Meta
              avatar={<Avatar shape="square" size={64} src={cover}/>}
              title={t.title}
              description={`Длительность: ${Math.floor(t.duration/1000)} сек`}
            />
          </List.Item>
        );
      }}
    />
  );
}
